import React from 'react';

import { truckingCompanyTypes } from '../constants/enums';

import { Spin } from 'antd';
import { isEmpty, isString } from 'lodash';

export const updateObject = (oldObject, updatedProperties) => {
  return {
    ...oldObject,
    ...updatedProperties,
  };
};

export const renderNoDataOrSpinner = (isLoading) => {
  return isLoading ? (
    <span style={{ display: 'block', textAlign: 'center' }}>
      <Spin size="small" />
    </span>
  ) : (
    <span style={{ display: 'block', textAlign: 'center' }}>No Data</span>
  );
};

export const getPermissionsByContactType = (permissions, contactType) => {
  if (permissions && contactType !== null && contactType !== undefined) {
    switch (contactType) {
      case truckingCompanyTypes.Insured:
        return permissions.permissions_TruckingCompanies_Insureds;
      case truckingCompanyTypes.Prospect:
        return permissions.permissions_TruckingCompanies_Prospects;
      case truckingCompanyTypes.MGA:
        return permissions.permissions_TruckingCompanies_MGAs;
      case truckingCompanyTypes.Carrier:
        return permissions.permissions_TruckingCompanies_Carriers;
      case truckingCompanyTypes.FinanceCompany:
        return permissions.permissions_TruckingCompanies_FinanceCompanies;
      case truckingCompanyTypes.ReferralSource:
        // TODO: add field to the Database
        return { canView: true, canEdit: true, canAdd: true, canDelete: true };
      case truckingCompanyTypes.Other:
        // TODO: add field to the Database
        return { canView: true, canEdit: true, canAdd: true, canDelete: true };
    }
  } else {
    return { canView: false, canEdit: false, canAdd: false, canDelete: false };
  }
};

export const getPermissionsByCertificateOrLienHolder = (permissions, isLienHolder) => {
  if (permissions) {
    return isLienHolder === true ? permissions.permissions_TruckingCompanies_LienHolders : permissions.permissions_TruckingCompanies_CertHolders;
  } else {
    return { canView: false, canEdit: false, canAdd: false, canDelete: false };
  }
};

export const getImageUrlFromBytes = (bytes) => {
  if (bytes && bytes.byteLength > 0) {
    const blob = new Blob([bytes]);
    const url = URL.createObjectURL(blob);
    return url;
  }
};

export const dataURItoArrayBuffer = (dataURI) => {
  var byteString = atob(dataURI.split(',')[1]);

  var ab = new ArrayBuffer(byteString.length);

  var ia = new Uint8Array(ab);

  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  return ab;
};

export const getBase64 = (file, callbackGetResult) => {
  const reader = new FileReader();
  reader.addEventListener('load', () => callbackGetResult(reader.result));
  reader.readAsDataURL(file);
};

export const getArrayBuffer = (file, callbackGetResult) => {
  const reader = new FileReader();
  reader.addEventListener('load', () => callbackGetResult(reader.result));
  reader.readAsArrayBuffer(file);
};

export const addDashesToNumber = (number) => {
  if (!number) return number;

  const numWithoutDashes = number.replace(/[^0-9]/g, '');

  if (numWithoutDashes.length > 10) return number.slice(0, -1);

  const dashPlaces = [3, 6];

  return numWithoutDashes
    .split('')
    .reduce((acc, curr, i) => (dashPlaces.includes(i) ? [...acc, '-', curr] : [...acc, curr]), [])
    .join('');
};

export const stringToArrayBuffer = (stringBytes) => {
  var byteString = atob(stringBytes);

  var ab = new ArrayBuffer(byteString.length);

  var ia = new Uint8Array(ab);

  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  return ab;
};

export const GuidEmpty = '00000000-0000-0000-0000-000000000000';

export const validateGuid = (possibleGuid) => {
  return !!possibleGuid && isString(possibleGuid) && !isEmpty(possibleGuid) && possibleGuid !== GuidEmpty ? possibleGuid : undefined;
};

export const isGuid = (guidValue) => {
  return !isEmpty(guidValue) && isString(guidValue) && guidValue !== GuidEmpty;
};

export const escapeRegex = (string) => {
  return string.replace(/[/\-\\^$*+?.()|[\]{}]/g, '\\$&');
};

export const validateObj = (obj) => {
  if (!obj || typeof obj !== 'object') return undefined;

  return Object.fromEntries(Object.entries(obj).filter(([_, value]) => value !== null && value !== undefined));
};
